import { useEffect, useState } from "react";
import { Card, Tabs, ConfigProvider, Skeleton } from "antd";
import FunctionalButton from "../Common/FunctionalButton";
import CorrectionTab from "./CorrectionTab";
import useRemoveImage from "../../functions/Image/removeImage";
import ImageTab from "./ImageTab";
import { ReloadOutlined } from "@ant-design/icons";
import UpdateImageTab from "./UpdateImageTab";


export default function ItemDetailsCard(props) {
  const {
    plates,
    setPlates,
    itemDetailsCardRef,
    selectedPlateIndex,
    activeTabKey,
    setActiveTabKey,
    selectedItemKey,
    setSelectedItemKey,
    category,
    categoryLoading,
    setIsDisableButton,
    selectedSubCategory,
    setSelectedSubCategory,
    onReloadDetails,
    handleAlaCartOrder,
  } = props;

  const [isDisplayRetake, setIsDisplayRetake] = useState(false);
  const [isDisplayReload, setIsDisplayReload] = useState(false);
  const [isDisplayAlaCart, setIsDisplayAlaCart] = useState(true);

  const { removeImage } = useRemoveImage();

  const TAB_ITEM = [
    {
      label: "Capture",
      key: 1,
      children: (
        <ImageTab
          plates={plates}
          setPlates={setPlates}
          selectedPlateIndex={selectedPlateIndex}
          setIsDisableButton={setIsDisableButton}
          activeTabKey={activeTabKey}
        />
      ),
    },
    // Fake Tab for demo purpose
    {
      label: "Upload",
      key: 2,
      children: (
        <UpdateImageTab
          plates={plates}
          setPlates={setPlates}
          selectedPlateIndex={selectedPlateIndex}
          setIsDisableButton={setIsDisableButton}
          activeTabKey={activeTabKey}
        />
      ),
    },
    {
      label: "Menu",
      key: 3,
      children: (
        <CorrectionTab
          selectedItemKey={selectedItemKey}
          setSelectedItemKey={setSelectedItemKey}
          plates={plates}
          setPlates={setPlates}
          selectedPlateIndex={selectedPlateIndex}
          category={category}
          selectedSubCategory={selectedSubCategory}
          setSelectedSubCategory={setSelectedSubCategory}
        />
      ),
      disabled: plates[selectedPlateIndex]?.ai_image_data ? false : true,
    },
    
  ];

  const onRetakeClicked = () => {
    //Set image as Removed
    let updated_plates = JSON.parse(JSON.stringify(plates));

    removeImage(updated_plates[selectedPlateIndex].image_id);

    updated_plates[selectedPlateIndex].image_id = null;
    updated_plates[selectedPlateIndex].ai_image_data = null;
    updated_plates[selectedPlateIndex].items = [];

    setPlates(updated_plates);
  };

  useEffect(() => {
    if (
      activeTabKey == 1 &&
      plates[selectedPlateIndex]?.ai_image_data != null
    ) {
      setIsDisplayRetake(true);
      setIsDisplayReload(false);
      setIsDisplayAlaCart(false);
    } else if (activeTabKey == 2 && category.length === 0) {
      setIsDisplayReload(true);
      setIsDisplayRetake(false);
      setIsDisplayAlaCart(false);
    } else if (plates[selectedPlateIndex]?.ai_image_data != null) {
      setIsDisplayAlaCart(false);
    } else if (plates[selectedPlateIndex]?.ai_image_data == null) {
      setIsDisplayAlaCart(true);
      setIsDisplayRetake(false);
    } else {
      setIsDisplayRetake(false);
    }
  }, [activeTabKey, plates, selectedPlateIndex]);

  useEffect(() => {
    if (category.length > 0) setIsDisplayReload(false);
  }, [category]);

  return (
    <div ref={itemDetailsCardRef} style={{ height: "100%" }}>
      <Card
        style={{ height: "100%" }}
        styles={{ body: { height: "100%", padding: "0px 10px 10px 10px" } }}
      >
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                horizontalMargin: "0 0 10px 0",
                itemSelectedColor: "#22c8f8",
                inkBarColor: "#22c8f8",
              },
            },
          }}
        >
          <div style={{ height: "100%" }}>
            <Skeleton loading={categoryLoading}>
              <Tabs
                className="item-details"
                style={{ height: "100%" }}
                size="small"
                activeKey={activeTabKey}
                items={TAB_ITEM}
                tabBarExtraContent={
                  <>
                    <div
                      style={{ display: isDisplayAlaCart ? "unset" : "none" }}
                    >
                      <FunctionalButton
                        buttonClickFunction={handleAlaCartOrder}
                      >
                        Ala Carte Order
                      </FunctionalButton>
                    </div>
                    <div
                      style={{ display: isDisplayRetake ? "unset" : "none" }}
                    >
                      <FunctionalButton buttonClickFunction={onRetakeClicked}>
                        Retake Image
                      </FunctionalButton>
                    </div>
                    <div
                      style={{ display: isDisplayReload ? "unset" : "none" }}
                    >
                      <FunctionalButton
                        buttonClickFunction={onReloadDetails}
                        width="30px"
                        type="ghost"
                        icon={<ReloadOutlined />}
                      />
                    </div>
                  </>
                }
                onChange={(activeTabKey) => {
                  setActiveTabKey(activeTabKey);
                }}
              />
            </Skeleton>
          </div>
        </ConfigProvider>
      </Card>
    </div>
  );
}
